<template>
  <ImagePicker
    bg-color="white"
    class="image-picker"
    :content-style="{ height: `${IMAGE_SIZE}px`, width: `${IMAGE_SIZE}px` }"
    :disable="disable"
    :model-value="imageUrl"
    :readonly="readonly"
    :revert="Boolean(!imageUrl && existingUrl)"
    :revert-tooltip="`Revert to saved ${assetTypeLower} image`"
    round
    :tooltip="`Choose ${existingUrl ? 'a new' : 'your own'} image for this ${assetTypeLower}.`"
    @clear="$emit('clear')"
    @error="$emit('error', $event)"
    @revert="$emit('update:model-value', existingUrl)"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template #upload-message>
      <div class="row justify-center items-center text-no-wrap line-height-1">
        <q-icon name="cloud_upload" />
        <div class="q-mb-sm">Choose Image</div>
      </div>
    </template>
  </ImagePicker>
</template>

<script setup lang="ts">
import _toLower from 'lodash/toLower';
import { computed } from 'vue';
import ImagePicker from 'components/ImagePicker.vue';
import { ASSET_TYPE_NAMES } from 'src/services/constants';

const IMAGE_SIZE = 128;

defineOptions({ name: 'AssetPicture' });

const props = defineProps<{
  disable?: boolean;
  imageUrl?: string | null;
  existingUrl?: string | null;
  readonly?: boolean;
  type: keyof typeof ASSET_TYPE_NAMES;
}>();

defineEmits(['clear', 'error', 'update:model-value']);

const assetType = computed(() => ASSET_TYPE_NAMES[props.type]);
const assetTypeLower = computed(() => _toLower(assetType.value));
</script>

<style scoped lang="scss">
.image-picker {
  max-height: 128px;
}

.vehicle-default {
  top: -5px;
}
</style>
